// extracted by mini-css-extract-plugin
export default {"resetForm":"passwordResetForm_resetForm__7Ad2z","nameWrapper":"passwordResetForm_nameWrapper__Egwg4","extraWrapper":"passwordResetForm_extraWrapper__GXrC1"};